export const REGIONES_COMUNA = [
  {
    nombreRegion: "Arica y Parinacota",
    comunas: ["Arica"]
  },
  {
    nombreRegion: "Tarapacá",
    comunas: ["Alto Hospicio", "Iquique", "Pozo Almonte"]
  },
  {
    nombreRegion: "Antofagasta",
    comunas: ["Antofagasta", "Calama", "San Pedro de Atacama", "Sierra Gorda"]
  },
  {
    nombreRegion: "Atacama",
    comunas: ["Copiapó", "Tierra Amarilla"]
  },
  {
    nombreRegion: "Valparaíso",
    comunas: [
      "Calera",
      "Catemu",
      "Concón",
      "Hijuelas",
      "La Cruz",
      "Limache",
      "Nogales",
      "Olmué",
      "Puchuncaví",
      "Quillota",
      "Quilpué",
      "Quintero",
      "Valparaíso",
      "Villa Alemana",
      "Viña del Mar",
      "Zapallar"
    ]
  },
  {
    nombreRegion: "Metropolitana de Santiago",
    comunas: [
      "Alhué",
      "Buin",
      "Calera de Tango",
      "Cerrillos",
      "Cerro Navia",
      "Colina",
      "Conchalí",
      "Curacaví",
      "El Bosque",
      "El Monte",
      "Estación Central",
      "Huechuraba",
      "Independencia",
      "Isla de Maipo",
      "La Cisterna",
      "La Florida",
      "La Granja",
      "La Pintana",
      "La Reina",
      "Lampa",
      "Las Condes",
      "Lo Barnechea",
      "Lo Espejo",
      "Lo Prado",
      "Macul",
      "Maipú",
      "María Pinto",
      "Melipilla",
      "Padre Hurtado",
      "Paine",
      "Pedro Aguirre Cerda",
      "Peñaflor",
      "Peñalolén",
      "Pirque",
      "Providencia",
      "Pudahuel",
      "Puente Alto",
      "Quilicura",
      "Quinta Normal",
      "Recoleta",
      "Renca",
      "San Bernardo",
      "San Joaquín",
      "San José de Maipo",
      "San Miguel",
      "San Pedro",
      "San Ramón",
      "Santiago",
      "Talagante",
      "Vitacura",
      "Ñuñoa"
    ]
  },
  {
    nombreRegion: "Libertador Gral. Bernardo O’Higgins",
    comunas: [
      "Chépica",
      "La Estrella",
      "Las Cabras",
      "Litueche",
      "Lolol",
      "Marchigüe",
      "Nancagua",
      "Palmilla",
      "Paredones",
      "Peralillo",
      "Peumo",
      "Pichidegua",
      "Pichilemu",
      "Placilla",
      "Pumanque",
      "San Fernando",
      "San Vicente de Tagua Tagua",
      "Santa Cruz"
    ]
  },
  {
    nombreRegion: "Maule",
    comunas: [
      "Colbún",
      "Curepto",
      "Curicó",
      "Hualañé",
      "Licantén",
      "Linares",
      "Longaví",
      "Maule",
      "Molina",
      "Parral",
      "Pelarco",
      "Pencahue",
      "Rauco",
      "Romeral",
      "Río Claro",
      "Sagrada Familia",
      "San Clemente",
      "San Javier de Loncomilla",
      "San Rafael",
      "Talca",
      "Teno",
      "Villa Alegre",
      "Yerbas Buenas"
    ]
  },
  {
    nombreRegion: "Ñuble",
    comunas: [
      "Bulnes",
      "Chillán",
      "Chillán Viejo",
      "Coelemu",
      "Coihueco",
      "El Carmen",
      "Ninhue",
      "Pemuco",
      "Pinto",
      "Portezuelo",
      "Quillón",
      "Quirihue",
      "Ránquil",
      "San Carlos",
      "San Fabián",
      "San Ignacio",
      "San Nicolás",
      "Yungay",
      "Ñiquén"
    ]
  },
  {
    nombreRegion: "Biobío",
    comunas: [
      "Antuco",
      "Arauco",
      "Cabrero",
      "Cañete",
      "Chiguayante",
      "Concepción",
      "Coronel",
      "Curanilahue",
      "Hualpén",
      "Hualqui",
      "Laja",
      "Lebu",
      "Los Álamos",
      "Los Ángeles",
      "Lota",
      "Mulchén",
      "Nacimiento",
      "Negrete",
      "Penco",
      "Quilaco",
      "Quilleco",
      "San Pedro de la Paz",
      "San Rosendo",
      "Santa Bárbara",
      "Santa Juana",
      "Talcahuano",
      "Tomé",
      "Tucapel",
      "Yumbel"
    ]
  },
  {
    nombreRegion: "La Araucanía",
    comunas: [
      "Angol",
      "Carahue",
      "Cholchol",
      "Collipulli",
      "Cunco",
      "Curarrehue",
      "Freire",
      "Gorbea",
      "Lautaro",
      "Loncoche",
      "Los Sauces",
      "Nueva Imperial",
      "Padre Las Casas",
      "Perquenco",
      "Pitrufquén",
      "Pucón",
      "Renaico",
      "Temuco",
      "Teodoro Schmidt",
      "Victoria",
      "Vilcún",
      "Villarrica"
    ]
  },
  {
    nombreRegion: "Los Ríos",
    comunas: [
      "La Unión",
      "Lanco",
      "Los Lagos",
      "Mariquina",
      "Máfil",
      "Paillaco",
      "Río Bueno",
      "Valdivia"
    ]
  },
  {
    nombreRegion: "Los Lagos",
    comunas: [
      "Fresia",
      "Frutillar",
      "Llanquihue",
      "Los Muermos",
      "Osorno",
      "Puerto Montt",
      "Puerto Octay",
      "Puerto Varas",
      "Purranque",
      "Río Negro",
      "San Juan de la Costa",
      "San Pablo"
    ]
  }
];
export const REGIONES_COMUNA_PAGO = [
  {
    nombreRegion: "Arica y Parinacota",
    comunas: ["Arica", "Camarones", "General Lagos", "Putre"]
  },
  {
    nombreRegion: "Tarapacá",
    comunas: ["Alto Hospicio", "Camiña", "Colchane", "Huara", "Iquique", "Pica", "Pozo Almonte"]
  },
  {
    nombreRegion: "Antofagasta",
    comunas: ["Antofagasta", "Calama", "María Elena", "Mejillones", "Ollagüe", "San Pedro de Atacama", "Sierra Gorda", "Taltal", "Tocopilla"]
  },
  {
    nombreRegion: "Atacama",
    comunas: ["Alto del Carmen", "Caldera", "Chañaral", "Copiapó", "Diego de Almagro", "Freirina", "Huasco", "Tierra Amarilla", "Vallenar"]
  },
  {
    nombreRegion: "Coquimbo",
    comunas: ["Andacollo", "Canela", "Combarbalá", "Coquimbo", "Illapel", "La Higuera", "La Serena", "Los Vilos", "Monte Patria", "Ovalle", "Paihuano", "Punitaqui", "Río Hurtado", "Salamanca", "Vicuña"]
  },
  {
    nombreRegion: "Valparaíso",
    comunas: [
      "Algarrobo", "Cabildo", "Calera", "Calle Larga", "Cartagena", "Casablanca", "Catemu", "Concón",
      "El Quisco", "El Tabo", "Hijuelas", "Isla de Pascua", "Juan Fernández", "La Cruz", "La Ligua",
      "Limache", "Llaillay", "Los Andes", "Nogales", "Olmué", "Panquehue", "Papudo", "Petorca",
      "Puchuncaví", "Putaendo", "Quillota", "Quilpué", "Quintero", "Rinconada", "San Antonio",
      "San Esteban", "San Felipe", "Santa María", "Santo Domingo", "Valparaíso", "Villa Alemana",
      "Viña del Mar", "Zapallar"
    ]
  },
  {
    nombreRegion: "Metropolitana de Santiago",
    comunas: [
      "Alhué", "Buin", "Calera de Tango", "Cerrillos", "Cerro Navia", "Colina", "Conchalí",
      "Curacaví", "El Bosque", "El Monte", "Estación Central", "Huechuraba", "Independencia",
      "Isla de Maipo", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina",
      "Lampa", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú",
      "María Pinto", "Melipilla", "Ñuñoa", "Padre Hurtado", "Paine", "Pedro Aguirre Cerda",
      "Peñaflor", "Peñalolén", "Pirque", "Providencia", "Pudahuel", "Puente Alto", "Quilicura",
      "Quinta Normal", "Recoleta", "Renca", "San Bernardo", "San Joaquín", "San José de Maipo",
      "San Miguel", "San Pedro", "San Ramón", "Santiago", "Talagante", "Tiltil", "Vitacura"
    ]
  },
  {
    nombreRegion: "Libertador General Bernardo O'Higgins",
    comunas: [
      "Chépica", "Chimbarongo", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros",
      "La Estrella", "Las Cabras", "Litueche", "Lolol", "Machalí", "Malloa", "Marchigüe",
      "Mostazal", "Nancagua", "Olivar", "Palmilla", "Paredones", "Peralillo", "Peumo",
      "Pichidegua", "Pichilemu", "Placilla", "Pumanque", "Quinta de Tilcoco", "Rancagua",
      "Rengo", "Requínoa", "San Fernando", "San Vicente de Tagua Tagua", "Santa Cruz"
    ]
  },
  {
    nombreRegion: "Maule",
    comunas: [
      "Cauquenes", "Chanco", "Colbún", "Constitución", "Curepto", "Curicó", "Empedrado",
      "Hualañé", "Licantén", "Linares", "Longaví", "Maule", "Molina", "Parral", "Pelarco",
      "Pelluhue", "Pencahue", "Rauco", "Retiro", "Río Claro", "Romeral", "Sagrada Familia",
      "San Clemente", "San Javier de Loncomilla", "San Rafael", "Talca", "Teno", "Vichuquén", "Villa Alegre",
      "Yerbas Buenas"
    ]
  },
  {
    nombreRegion: "Ñuble",
    comunas: [
      "Bulnes", "Chillán", "Chillán Viejo", "Cobquecura", "Coelemu", "Coihueco", "El Carmen",
      "Ninhue", "Ñiquén", "Pemuco", "Pinto", "Portezuelo", "Quillón", "Quirihue", "Ránquil",
      "San Carlos", "San Fabián", "San Ignacio", "San Nicolás", "Treguaco", "Yungay"
    ]
  },
  {
    nombreRegion: "Biobío",
    comunas: [
      "Alto Biobío", "Antuco", "Arauco", "Cabrero", "Cañete", "Chiguayante", "Concepción",
      "Contulmo", "Coronel", "Curanilahue", "Florida", "Hualpén", "Hualqui", "Laja", "Lebu",
      "Los Álamos", "Los Ángeles", "Lota", "Mulchén", "Nacimiento", "Negrete", "Penco",
      "Quilaco", "Quilleco", "San Pedro de la Paz", "San Rosendo", "Santa Bárbara",
      "Santa Juana", "Talcahuano", "Tirúa", "Tomé", "Tucapel", "Yumbel"
    ]
  },
  {
    nombreRegion: "La Araucanía",
    comunas: [
      "Angol", "Carahue", "Cholchol", "Collipulli", "Cunco", "Curacautín", "Curarrehue",
      "Ercilla", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Lonquimay",
      "Los Sauces", "Lumaco", "Melipeuco", "Nueva Imperial", "Padre Las Casas", "Perquenco",
      "Pitrufquén", "Pucón", "Purén", "Renaico", "Saavedra", "Temuco", "Teodoro Schmidt",
      "Toltén", "Traiguén", "Victoria", "Vilcún", "Villarrica"
    ]
  },
  {
    nombreRegion: "Los Ríos",
    comunas: [
      "Corral", "Futrono", "La Unión", "Lago Ranco", "Lanco", "Los Lagos", "Máfil",
      "Mariquina", "Paillaco", "Panguipulli", "Río Bueno", "Valdivia"
    ]
  },
  {
    nombreRegion: "Los Lagos",
    comunas: [
      "Ancud", "Calbuco", "Castro", "Chaitén", "Chonchi", "Cochamó", "Curaco de Vélez",
      "Dalcahue", "Fresia", "Frutillar", "Futaleufú", "Hualaihué", "Llanquihue",
      "Los Muermos", "Maullín", "Osorno", "Palena", "Puerto Montt", "Puerto Octay",
      "Puerto Varas", "Puqueldón", "Purranque", "Puyehue", "Quemchi", "Queilén",
      "Quellón", "Quinchao", "Río Negro", "San Juan de la Costa", "San Pablo"
    ]
  },
  {
    nombreRegion: "Aysén del General Carlos Ibáñez del Campo",
    comunas: ["Aysén", "Chile Chico", "Cisnes", "Cochrane", "Coyhaique", "Guaitecas", "Lago Verde", "O'Higgins", "Río Ibáñez", "Tortel"]
  },
  {
    nombreRegion: "Magallanes y de la Antártica Chilena",
    comunas: [
      "Antártica", "Cabo de Hornos", "Laguna Blanca", "Natales", "Porvenir", "Primavera",
      "Punta Arenas", "Río Verde", "San Gregorio", "Timaukel", "Torres del Paine"
    ]
  }
];